// extracted by css-extract-rspack-plugin
export default {"age_rating":"ZiKYO","ageRating":"ZiKYO"};